import { rc } from "./rc";

export const gd_stats = {
  rc,
};
